import type { ReactNode } from 'react';
import AuthProvider from '@/app/login/context/AuthProvider';
import { ThemeProvider } from '@/shared/lib/theme';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/toast';
import { RecsysSubscriptions } from '@/app/recsys/RecsysSubscriptions';

export default function RootLayout({ children }: {
  children: ReactNode;
}) {
  return (<ThemeProvider>
    <TooltipProvider>
      <AuthProvider>
        <RecsysSubscriptions />
        <Toaster />
        {children}
      </AuthProvider>
    </TooltipProvider>
  </ThemeProvider>);
}
